import api from "../services";

const payRollApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPayRollData: builder.query({
      query: (params) => ({
        url: `api/payslipmanagement/payrollgridemployeesdetails`,
        method: "GET",
        params,
      }),
    }),
    getPayRollDataByEmployees: builder.query({
      query: (params) => ({
        url: `api/payslipmanagement/exportpayrollgrid`,
        method: "GET",
        params,
      }),
    }),
    auditPayslipDownload: builder.mutation({
      query: (payload) => ({
        url: "api/payslipmanagement/audit/download",
        method: "POST",
        body: payload,
      }),
    }),
    getPayrollSettings: builder.query({
      query: ({month, year }) => ({
        url: `api/payrollsettings/fetchsettings`,
        method: "GET",
        params: { month, year },
      }),
    }),
    getLockedMonths: builder.query({
      query: ({ tenantId, year }) => ({
        url: `api/payrollsettings/fetchlockedmonths`,
        method: "GET",
        params: { tenantId, year },
      }),
    }),
    lockPayroll: builder.mutation({
      query: ({ tenantId, month, year }) => ({
        url: `api/payrollsettings/lock`,
        method: "PUT",
        params: { month, year },
      }),
    }),
    unlockPayroll: builder.mutation({
      query: ({ month, year }) => ({
        url: `api/payrollsettings/unlock`,
        method: "PUT",
        params: { month, year },
      }),
    }),
    releasePayroll: builder.mutation({
      query: ({ tenantId, month, year }) => ({
        url: `api/payrollsettings/release`,
        method: "PUT",
        params: { tenantId, month, year },
        responseHandler: "text",
      }),
    }),
  }),
});

export default payRollApi;
export const {
  useLazyGetPayRollDataQuery,
  useLazyGetPayRollDataByEmployeesQuery,
  useLazyGetPayrollSettingsQuery,
  useLazyGetLockedMonthsQuery,
  useLockPayrollMutation,
  useUnlockPayrollMutation,
  useReleasePayrollMutation,
  useAuditPayslipDownloadMutation,
} = payRollApi;
